import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "AvatarWrapper",
  componentId: "sc-9lv2x5-0"
})(["box-sizing:content-box;display:inline-flex;position:relative;transition-delay:150ms;transition:margin ease 300ms;flex-shrink:0;", ""], ({
  $cssStyles
}) => $cssStyles);